"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminComponent = exports.AdminComponentContent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const isMounted_1 = __importDefault(require("src/configeek_assets/src/system/hooks/isMounted"));
const AdminMGTProvider_1 = require("src/configeek_assets/src/components/loggedIn/content/admin/AdminMGTProvider");
const PageLoaderComponent_1 = require("src/configeek_assets/src/components/common/widget/PageLoaderComponent");
const AdminDashboard_1 = require("src/configeek_assets/src/components/loggedIn/content/admin/dashboard/AdminDashboard");
const AdminComponentContent = () => {
    const isMounted = (0, isMounted_1.default)();
    const context = (0, AdminMGTProvider_1.useAdminMGTContext)();
    (0, react_1.useEffect)(() => {
        if (isMounted()) {
            (async () => {
                await context.checkHasAccess();
            })();
        }
    }, [isMounted]);
    if (!context.validation.validated || !context.validation.valid) {
        return React.createElement(PageLoaderComponent_1.PageLoaderComponent, null);
    }
    return React.createElement(React.Fragment, null,
        React.createElement(AdminDashboard_1.AdminDashboard, null));
};
exports.AdminComponentContent = AdminComponentContent;
const AdminComponent = () => {
    return React.createElement(AdminMGTProvider_1.AdminMGTProvider, null,
        React.createElement(exports.AdminComponentContent, null));
};
exports.AdminComponent = AdminComponent;
